import React from 'react';
import { Link } from 'react-router';

import { IconButton as RadixIconButton } from '@radix-ui/themes';
import classNames from 'classnames';

import { getFlyToRadixColor, renderIcon } from '../utils';
import {
  IconButtonProps,
  sizeToClassNameMap,
  sizeToIconSizeMap,
} from './IconButton.types';

// TODO: It would be good for accessibility to pass have aria-label and a tooltip, which describes button action

function IconButton({
  color = 'accent',
  size = '2',
  to,
  iconSize,
  icon,
  className,
  iconClassName = '',
  type = 'button',
  ref,
  ...props
}: IconButtonProps & { ref?: React.Ref<HTMLButtonElement> }) {
  const innerContent = renderIcon(
    icon,
    iconSize || sizeToIconSizeMap[size],
    iconClassName
  );

  let content = innerContent;
  if (to) {
    content = <Link to={to}>{innerContent}</Link>;
  }

  return (
    <RadixIconButton
      color={getFlyToRadixColor(color)}
      ref={ref}
      size={size}
      className={classNames(
        sizeToClassNameMap[size],
        className,
        props.variant === 'ghost' && 'm-0',
        'box-border'
      )}
      asChild={!!to}
      type={type}
      {...props}
    >
      {content}
    </RadixIconButton>
  );
}

export { IconButton };
